<template>
  <v-divider class="primary ma-5" />
</template>

<script>
export default {
  name: "CustomDivider",
};
</script>

<style scoped></style>
